export const UPPER_CHANNEL = 'up';
export const DOWN_CHANNEL = 'down';
